/* unplugin-vue-components disabled */import { render } from "./AuthItemPreview.vue?vue&type=template&id=5cdfd4d3&scoped=true&ts=true"
import script from "./AuthItemPreview.vue?vue&type=script&lang=ts"
export * from "./AuthItemPreview.vue?vue&type=script&lang=ts"

import "./AuthItemPreview.vue?vue&type=style&index=0&id=5cdfd4d3&lang=scss"
import "./AuthItemPreview.vue?vue&type=style&index=1&id=5cdfd4d3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdfd4d3"]])

export default __exports__